import React, { useState } from "react";
import "./Header.css";
import {
  Row,
  Col,
  Menu,
  Dropdown,
  Icon,
  Button,
  Typography,
  Modal,
} from "antd";
import logo from "../../assets/images/header-logo.png";
import UserSession from "../../service/UserSession";
import { Link, useHistory } from "react-router-dom";
import { USER_DETAILS } from "../../constants/graphql-query";
import { useQuery } from "react-apollo";
import { miliphoreCounties } from "../../constants/app-constant";
import sigmaLogo from "../../assets/images/header-logo-ms.png";
import CountrySelect from "../CountrySelectionComponent";

const { Title } = Typography;

export default () => {
  let history = useHistory();

  const _country = localStorage.getItem("_country");
  const { pathname } = history.location;

  const logout = () => {
    UserSession.clearSession();
    history.push("/login");
  };

  let userName = "";
  if (UserSession.getLogonId()) {
    const { data } = useQuery(USER_DETAILS, {
      variables: { logonId: UserSession.getLogonId() },
      fetchPolicy: "no-cache",
      errorPolicy: "all",
    });

    if (data && data.user) userName = data.user.firstName;
  }

  const menu = (
    <Menu>
      <Menu.Item key="0">
        <Link to={"/user-profile"}>View / Edit Profile</Link>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="1">
        <a href="#" onClick={() => logout()}>
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  const [state, setState] = useState({ visible: false });

  const showModal = () => {
    setState({
      visible: true,
    });
  };

  const handleOk = (e) => {
    setState({
      visible: false,
    });
  };

  const handleCancel = (e) => {
    console.log(e);
    setState({
      visible: false,
    });
  };

  return (
    <div className="header">
      <Row className="header-bg">
        <Col span={17}></Col>
        {
          _country ? (
          <Col span={3} align="center" className="location-change">
            <Title onClick={showModal} level={4}>
              {_country}
            </Title>
          </Col>
          ) : (
            <Col span={3} />
          )
        }        
        {userName ? (
          <Col span={2} className="profile-drop" align="middle">
            <Dropdown overlay={menu} trigger={["click"]}>
              <a className="ant-dropdown-link" href="#">
                {userName} <Icon type="down" />
              </a>
            </Dropdown>
          </Col>
        ) : (
          ""
        )}
      </Row>
      <Row className="header-logo">
        <Col span={3} align="center">
          {(pathname === "/user-profile" ||
            pathname === "/register" ||
            pathname === "/forgotPassword") && (
            <Link to={"/biom"}>
              <Button icon="arrow-left" size="small">
                Back
              </Button>
            </Link>
          )}
        </Col>
        <Col span={21}>
          <Link to={"/biom"}>
            <img
              src={
                _country && miliphoreCounties.indexOf(_country) !== -1
                  ? sigmaLogo
                  : logo
              }
              alt="footer logo"
            />
          </Link>
        </Col>
      </Row>
      {
        state.visible && (
          <Modal
            title={
              <Title level={3} className="location-title">
                Location
              </Title>
            }
            visible={state.visible}
            width={900}
            style={{ top: 30 }}
            onOk={handleOk}
            footer={false}
            onCancel={handleCancel}
          >
          <CountrySelect handleOk={handleOk}isModal={true} />
          </Modal>
        )
      }
    </div>
  );
};
